import { render, staticRenderFns } from "./GrupoDetalle.vue?vue&type=template&id=46c5dfcf&"
import script from "./GrupoDetalle.vue?vue&type=script&lang=js&"
export * from "./GrupoDetalle.vue?vue&type=script&lang=js&"
import style0 from "./GrupoDetalle.vue?vue&type=style&index=0&id=46c5dfcf&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports